import Axios from 'axios';
import type { OrgLaunchSettings } from '@bb/automaton';
import type { BuildJsonType } from '@bb/domain/dist/types';

const getOrgLaunchSetting = async (): Promise<OrgLaunchSettings> => {
  const { data } = await Axios.get<BuildJsonType<OrgLaunchSettings>>(
    '/org/launch_setting',
  );

  const toDateOrUndefined = (str: string | undefined | null) =>
    str ? new Date(str) : undefined;

  return {
    ...data,
    launchDate: toDateOrUndefined(data.launchDate),
    launchDateStart: toDateOrUndefined(data.launchDateStart),
    launchDateEnd: toDateOrUndefined(data.launchDateEnd),
    blockedSpecialDays: data.blockedSpecialDays.map(d => new Date(d)),
  };
};

export default getOrgLaunchSetting;
